import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import '../index.css'

const menuItems = [
  { name: "Home", to: "home" },
  { name: "About Us", to: "about" },
  { name: "Our Services", to: "service" },
  // { name: "Our Partners", to: "client" }
];

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [active, setActive] = useState("home"); // ⭐ ACTIVE STATE

  const handleMenuClick = () => setShowMenu(!showMenu);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY >= 33);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 z-50 w-full h-[70px] flex justify-between items-center px-4 text-black transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      {/* Logo */}
      <div className="text-2xl cursor-pointer inline-flex items-center text-blue-900">
        <Link to="home" smooth duration={500} onClick={() => setActive("home")}>
          <h1>Yug Real Estate</h1>
        </Link>
      </div>

      {/* Mobile Icon */}
      <div className="md:hidden" onClick={handleMenuClick}>
        {showMenu ? (
          <svg className="h-6 w-6 text-black" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M14.95 5.879l-1.414-1.414L10 8.586 6.464 5.05 5.05 6.464 8.586 10l-3.536 3.536 1.414 1.414L10 11.414l3.536 3.536 1.414-1.414L11.414 10l3.536-3.536z"
              clipRule="evenodd"
            />
          </svg>
        ) : (
          <svg className="h-6 w-6 text-black" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 16a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </div>

      {/* Desktop Menu */}
      <ul className="hidden md:flex space-x-6">
        {menuItems.map((item) => (
          <li key={item.to} className="cursor-pointer">
            <Link
              to={item.to}
              smooth
              duration={500}
              onClick={() => setActive(item.to)}
              className={`transition-colors ${
                active === item.to ? "text-blue-900 font-semibold" : "text-black"
              }`}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>

      {/* Contact Button Desktop */}
      <div className="hidden md:flex">
        <button className="px-4 py-2 bg-blue-900 text-white rounded-md hover:bg-gray-600">
          <Link to="contact" smooth duration={500} onClick={() => setActive("contact")}>
            Contact Us
          </Link>
        </button>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={`${
          showMenu ? "flex" : "hidden"
        } md:hidden flex flex-col bg-blue-900 text-white w-full absolute top-16 left-0`}
      >
        {menuItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            smooth
            duration={500}
            onClick={() => {
              setActive(item.to);
              handleMenuClick();
            }}
            className={`p-3 cursor-pointer ${
              active === item.to ? "bg-gray-700" : ""
            }`}
          >
            {item.name}
          </Link>
        ))}

        <Link
          to="contact"
          smooth
          duration={500}
          onClick={() => {
            setActive("contact");
            handleMenuClick();
          }}
          className={`p-3 cursor-pointer ${
            active === "contact" ? "bg-gray-700" : ""
          }`}
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
